export var backendServer =
  process.env.NODE_ENV === "development"
    ? "https://api.mitattu.fi/"
    : "https://api.mitattu.fi/";
